import { useCallback } from "react";

const STORAGE_KEY = "@chat/drafts";

const getDrafts = () => JSON.parse(localStorage.getItem(STORAGE_KEY) || "{}");

const removeDraft = (key) => {
    const drafts = getDrafts();

    if (drafts[key]) {
        delete drafts[key];
        localStorage.setItem(STORAGE_KEY, JSON.stringify(drafts));
    }
};

const updateDraft = (key, value) => {
    const drafts = getDrafts();

    if (!value) {
        delete drafts[key];
    } else {
        drafts[key] = value;
    }

    localStorage.setItem(STORAGE_KEY, JSON.stringify(drafts));
};

const useDraftAPI = () => {
    const queryParams = new URLSearchParams(window.location.search)
    const appointmentId = queryParams.get("appointment_id");

    const handleUpdateDraftMessage = useCallback(
        (e) => {
            updateDraft(appointmentId, e.target.value);
        },
        [appointmentId],
    );

    const getMainInputDraft = useCallback(() => {
        const drafts = getDrafts();
        return drafts[appointmentId] || "";
    }, [appointmentId]);

    const handleRemoveDraftMessage = useCallback(() => {
        removeDraft(appointmentId);
    }, [appointmentId])

    return {
        getMainInputDraft,
        handleUpdateDraftMessage,
        handleRemoveDraftMessage,
    };
};

export default useDraftAPI